
export default {
  name: 'FullwidthBlok',
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
}
